module.exports = __webpack_public_path__ + "7cf15aeaa44cb50dff611ea71e834528.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard_tags_2x.png
// module id = 101
// module chunks = 0 1 2 3 4